// extracted by mini-css-extract-plugin
export default {"status":"status_StatusIno-module_1dYrz","square":"square_StatusIno-module_2hU47"};